import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    if (typeof Swiper !== 'undefined') {
        let swipers = document.querySelectorAll('[paws-component="noss-wysiwyg"][paws-template="zitate"] .swiper');

        for (let i = 0; i < swipers.length; ++i) {
            let config = {
                slidesPerView: 1,
                loop: true,
                on: {
                    init: function () {
                        if (window.lazyLoadInstance) {
                            window.lazyLoadInstance.update();
                        }
                    },
                },
            }

            let paginationEl = swipers[i].closest('[paws-component]').querySelector('.swiper-pagination');
            if (paginationEl !== null) {
                config.pagination = {el: paginationEl, clickable: true};
            }

            let nextEl = swipers[i].closest('[paws-component]').querySelector('.btn-next');
            let prevEl = swipers[i].closest('[paws-component]').querySelector('.btn-prev');
            if (nextEl !== null && prevEl !== null) {
                config.navigation = {nextEl: nextEl, prevEl: prevEl};
            }

            let mySwiper = new Swiper(swipers[i], config);
        }
    }
}